import React, { useState } from "react";
import Slider from "react-slick";

export function ProcessCardWidget({ process, configuration }) {
  const [showAllGroups, setShowAllGroups] = useState(false);
  const [showAllRoles, setShowAllRoles] = useState(false);


  const handleToggleGroups = (e) => {
    e.preventDefault();
    setShowAllGroups(!showAllGroups);
  };

  const handleToggleRoles = (e) => {
    e.preventDefault();
    setShowAllRoles(!showAllRoles);
  };

  const itemsToShowGroups = showAllGroups
    ? process.groups
    : process.groups.slice(0, 2);
  const itemsToShowRoles = showAllRoles
    ? process.roles
    : process.roles.slice(0, 1);

  let processClass = "Banner";
  let statusClass = "open_discussion_group";
  if (process.private) {
    processClass = "Banner private";
    statusClass = "close_discussion_group";
  }
  let url = process.url;
  if (process.private) url = null;

  let phaseInfo = "";
  let iconphase = "";
  if (process.current_phase) {
    iconphase = `icon-${process.current_phase.phase_type}`;
    phaseInfo = (
      <div className="BannerTitu">
        {process.multiphase ? (
          <>
            <i
              className="icon-processes"
              title={configuration.translations.multiPhaseText}
            ></i>
            <span>{configuration.translations.multiPhaseText}</span>
          </>
        ) : (
          <>
            <i
              className={iconphase}
              title={process.current_phase.phase_type_display}
            ></i>
            <span>{process.current_phase.phase_type_display}</span>
          </>
        )}
      </div>
    );
  }


  return (
    <a className={processClass} href={url}>
      <div className="BannerCont">
        <div className={statusClass}>.</div>
        {phaseInfo}
        {process.roles.length > 0 && (
          <div className="BannerRole">
            <i className="icon-administracion"></i>
            <div className="BannerRole-group">
            {itemsToShowRoles.map((role, index) => (
              <span key={index} className="BannerRole-title">
                {role}
              </span>
            ))}
            </div>
            {process.roles.length > 1 && (
              <button onClick={handleToggleRoles} className="show-more-button2">
                <i class={showAllRoles ? `icon-despliega_arriba` : `icon-despliega_abajo`}></i>
              </button>
            )}
          </div>
        )}
        <div className="BannerText">{process.name}</div>


        <div className="Cipa">
          <span>{configuration.translations.takePart}</span>
          <i className="icon-arrow-small"></i>
        </div>
      </div>
      <div></div>

      {/* Mostrar Grupos */}
      <div className="imgBanner">
        {process.groups.length > 0 && (
          <div className="BannerContainerGroup">
            <i className="icon-educacion"></i>
            <div className="BannerGroup">
              {itemsToShowGroups.map((group, index) => (
                <span key={index} className="BannerGroup-item">
                  {group}
                </span>
              ))}
            </div>
            {process.groups.length > 2 && (
              <button onClick={handleToggleGroups} className="show-more-button">
                <i class={showAllGroups  ? `icon-despliega_arriba` : `icon-despliega_abajo`}></i>
              </button>
            )}
          </div>
        )}
        <img src={process.list_image} alt={process.name} />
      </div>
    </a>
  );
}
